import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetOrganizationStructure } from '../../store/HR/Organizations/OrganizationStructureSice';
import { useTranslation } from 'react-i18next';

const useGetOrganizationStructure = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetOrganizationStructure());
  }, [dispatch]);
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const {
    OrgStructureList: data,
    loading,
    error
  } = useSelector(state => state.OrganizationStructure);

  //#region   //~~~~~~~~~~~~~~~ buildHierarchy ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const getIconByType = type => {
    const styles = {
      120: { icon: 'bi bi-people-fill', color: 'text-primary' }, // Department
      100: { icon: 'bi bi-grid', color: 'text-success' }, // Unit
      110: { icon: 'bi bi-buildings', color: 'text-danger' }, // Factory
      160: { icon: 'bi bi-tools', color: 'text-warning' }, // Workshop
      130: { icon: 'bi bi-box-seam', color: 'text-info' }, // Inventory
      150: { icon: 'bi bi-geo-alt', color: 'text-secondary' }, // Branch
      180: { icon: 'bi bi-file-earmark-text', color: 'text-dark' }, // Legal Entity
      30: { icon: 'bi bi-building', color: 'text-theme' }, // Company
      40: { icon: 'bi bi-briefcase', color: 'text-muted' }, // Office
      70: { icon: 'bi bi-map', color: 'text-success' }, // Region
      20: { icon: 'bi bi-house-door', color: 'text-danger' }, // Main Branch
      10: { icon: 'bi bi-diagram-3', color: 'text-warning' }, // Business Group
      210: { icon: 'bi bi-house', color: 'text-info' }, // Housing Complex
      60: { icon: 'bi bi-diagram-2', color: 'text-secondary' }, // Project
      140: { icon: 'bi bi-layers', color: 'text-dark' }, // Section
      170: { icon: 'bi bi-gear-wide', color: 'text-primary' }, // Enterprise Asset Management
      90: { icon: 'bi bi-heart-pulse', color: 'text-success' }, // Medical Service Provider
      200: { icon: 'bi bi-layout-split', color: 'text-danger' }, // Sub Section
      50: { icon: 'bi bi-boxes', color: 'text-warning' }, // Production
      80: { icon: 'bi bi-shop', color: 'text-info' } // Shop
    };

    // إذا لم يتم العثور على النوع، قم بإرجاع الإعدادات الافتراضية
    return styles[type] || { icon: 'bi bi-question-circle', color: 'text-body' };
  };

  // function buildHierarchy() {
  //   const map = new Map();
  //   let root;

  //   // إنشاء العقد وتخزينها في الخريطة
  //   data?.forEach(item => {
  //     const node = {
  //       id: item.organizationIdChild,
  //       name: i18n.language === 'en' ? item.childName : item.childName2,
  //       type: item.childType,
  //       iconStyle: getIconByType(item.childType),
  //       children: []
  //     };
  //     map.set(node.id, node);

  //     // تحديد العقدة الجذر
  //     if (item.organizationIdChild === item.organizationIdParent) {
  //       root = node;
  //     }
  //   });

  //   // ربط العقد بأطفالها
  //   data?.forEach(item => {
  //     if (item.organizationIdChild !== item.organizationIdParent) {
  //       const parent = map.get(item.organizationIdParent);
  //       if (parent) {
  //         parent.children.push(map.get(item.organizationIdChild));
  //       }
  //     }
  //   });

  //   return root;
  // }

  function buildHierarchy() {
    const map = new Map();
    let root;
  
    // إنشاء العقد وتخزينها في الخريطة
    data?.forEach(item => {
      const node = {
        structureId: item.id,
        id: item.organizationIdChild,
        name: i18n.language === 'en' ? item.childName : item.childName2,
        type: item.childType,
        iconStyle: getIconByType(item.childType),
        children: [],
        childrenCount: 0  // Add children count property
      };
      map.set(node.id, node);
  
      // تحديد العقدة الجذر
      if (item.organizationIdChild === item.organizationIdParent) {
        root = node;
      }
    });
  
    // ربط العقد بأطفالها وحساب عدد الأبناء
    data?.forEach(item => {
      if (item.organizationIdChild !== item.organizationIdParent) {
        const parent = map.get(item.organizationIdParent);
        const child = map.get(item.organizationIdChild);
        if (parent) {
          parent.children.push(child);
          parent.childrenCount += 1; // Increment the children count for the parent
        }
      }
    });
  
    return root;
  }
  
  const Hierarchy = buildHierarchy();

  //#endregion
  return { loading, error, data, Hierarchy };
};

export default useGetOrganizationStructure;
